import Vue from 'vue';

Vue.directive('focus', {

  inserted(el) {
    let selector = 'input[type=text]';
    selector += ', input[type=password]';
    selector += ', input[type=number]';
    const field = el.querySelectorAll(selector)[0];
    if (field) {
      field.focus();
    }
  },

});

Vue.directive('onlynumbers', (el) => {
  let selector = 'input[type=text]';
  selector += ', input[type=number]';
  const field = el.querySelector(selector);
  if (field) {
    field.addEventListener('input', () => {
      field.value = field.value.replace(/[^0-9]/g, '');
    });
  }
});
